import * as React from "react";
const FacebookSvg = (props) => (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.988 0c6.618 0 11.989 5.37 11.989 11.988a11.954 11.954 0 0 1-10.108 11.824v-8.355h2.79l.53-3.457h-.02l.005-.024h-3.318V9.753c0-.95.482-1.876 1.963-1.876h1.507V4.938s-.006 0-.017-.003v-.009s-1.358-.247-2.666-.247c-2.741 0-4.519 1.667-4.519 4.667v2.642H7.062v3.457h.016v.012h3.046v8.371A11.976 11.976 0 0 1 0 11.988C0 5.371 5.37 0 11.988 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default FacebookSvg;
